export default "__VITE_ASSET__BAVDhF1w__"